interface Api {
	get: (name: string) => any;
	set: (name: string, componentOrStore: any) => void;
}

export const BettyRoutes = (function () {
	const components = {};
	const api = {} as Api;

	api.get = function (name: string) {
		return components[name];
	};

	api.set = function (name: string, component: any) {
		components[name] = component;
	};

	return api;
})();

export const BettyStores = (function () {
	const stores = {};
	const api = {} as Api;

	api.get = function (name: string) {
		return stores[name];
	};

	api.set = function (name: string, refluxStore: any) {
		stores[name] = refluxStore;
	};

	return api;
})();
